import ListMarche from '@/views/achat/marche/l_marche';
import AddEditMarche from '@/views/achat/marche/m_marche';
import DetailMarche from '@/views/achat/marche/c_marche';
import FournisseurSupport from '@/views/achat/fournisseurSupport/l_fournisseurSupport';
import AddEditFournisseurSupport from '@/views/achat/fournisseurSupport/m_fournisseurSupport';
import DetailFournisseurSupport from '@/views/achat/fournisseurSupport/c_fournisseurSupport';
import LieuDeLivraison from '@/views/achat/lieuDeLivraison/l_lieuDeLivraison';
import EditionFournisseur from '@/views/commun/fournisseur/m_fournisseur';
import ConsultationFournisseur from '@/views/commun/fournisseur/c_fournisseur';
import ListeFournisseurs from '@/views/achat/fournisseurs/l_fournisseurs';
import AddEditFournisseurs from '@/views/achat/fournisseurs/m_fournisseurs';
import ConsultationFournisseurs from '@/views/achat/fournisseurs/c_fournisseurs';
import ListeCommmande from '@/views/achat/commande/l_commandeAchatFournisseur';
import AddEditCommande from '@/views/achat/commande/m_commandeAchatFournisseur';
import DetailCommande from '@/views/achat/commande/c_commandeAchatFournisseur';
import ListeLigneCommandeAchat from '@/views/achat/lignesCommandeAchat/l_listeLigneCommandeAchat';
import ListeFactures from '@/views/achat/facture/l_factureAchatFournisseur';
import AddEditFacture from '@/views/achat/facture/m_factureAchatFournisseur';
import DetailFacture from '@/views/achat/facture/c_factureAchatFournisseur';
import ListePaiementsFactures from '@/views/achat/facture/l_paiements';
import ListeJournalPaiementsFactures from '@/views/achat/facture/l_journalPaiements';
import ListeLotPaiementFactures from '@/views/achat/facture/l_lotDePaiement';
import detailLotPaiement from '@/views/baux/lotPaiement/c_lotPaiement';
import editionLotPaiement from '@/views/baux/lotPaiement/m_lotPaiement';
import ListeSuiviAchats from '@/views/achat/suiviAchats/l_suiviAchats';

export default [
  {
    path: '/listeMarche/:fournisseurId?',
    component: ListMarche,
    name: 'l.presse.marche',
  },
  {
    path: '/addMarche',
    component: AddEditMarche,
    name: 'm.presse.marche-add',
  },
  {
    path: '/editMarche/:id',
    component: AddEditMarche,
    name: 'm.presse.marche-edit',
  },
  {
    path: '/detailMarche/:id/:activeTab?',
    component: DetailMarche,
    name: 'c.presse.marche',
  },
  {
    path: '/listeFournisseurSupport',
    component: FournisseurSupport,
    name: 'l.presse.fournisseur_support',
  },
  {
    path: '/addFournisseurSupport/:id?',
    component: AddEditFournisseurSupport,
    name: 'm.presse.fournisseur_support',
  },
  {
    path: '/detailFournisseurSupport/:id',
    component: DetailFournisseurSupport,
    name: 'c.presse.fournisseur_support',
  },
  {
    path: '/lieuDeLivraison',
    component: LieuDeLivraison,
    name: 'l.achat.lieu_de_livraison',
  },
  {
    path: '/lieuDeLivraison/:id?',
    component: EditionFournisseur,
    name: 'm.achat.lieu_de_livraison',
  },
  {
    path: '/detailLieuDeLivraison/:id?',
    component: ConsultationFournisseur,
    name: 'c.achat.lieu_de_livraison',
  },
  {
    path: '/listeFournisseurs',
    component: ListeFournisseurs,
    name: 'l.achat.fournisseurs',
  },
  {
    path: '/addFournisseurs',
    component: AddEditFournisseurs,
    name: 'm.achat.fournisseurs',
  },
  {
    path: '/detailFournisseurs/:id',
    component: ConsultationFournisseurs,
    name: 'c.achat.fournisseurs',
  },
  {
    path: '/listeCommmandesAchatFournisseur',
    component: ListeCommmande,
    name: 'l.achat.commandes',
  },
  {
    path: '/addEditCommandeAchatFournisseur/:referenceExterne?',
    component: AddEditCommande,
    name: 'm.achat.commandes-creation',
  },
  {
    path: '/addEditCommandeAchatFournisseur/:id',
    component: AddEditCommande,
    name: 'm.achat.commandes',
  },
  {
    path: '/detailCommandeAchatFournisseur/:id',
    component: DetailCommande,
    name: 'c.achat.commandes',
  },
  {
    path: '/listeLigneCommandeAchat',
    component: ListeLigneCommandeAchat,
    name: 'l.achat.commandes-ligne_commande_achat',
  },
  {
    path: '/listeBonReception',
    component: ListeCommmande,
    name: 'l.achat.bon_reception',
  },
  {
    path: '/addEditBonReception/:id?',
    component: AddEditCommande,
    name: 'm.achat.bon_reception',
  },
  {
    path: '/detailBonReception/:id',
    component: DetailCommande,
    name: 'c.achat.bon_reception',
  },
  {
    path: '/listeFacturesAchatFournisseur',
    component: ListeFactures,
    name: 'l.achat.factures',
  },
  {
    path: '/addEditFactureAchatFournisseur/:id?',
    component: AddEditFacture,
    name: 'm.achat.factures',
  },
  {
    path: '/detailFactureAchatFournisseur/:id',
    component: DetailFacture,
    name: 'c.achat.factures',
  },
  {
    path: '/listePaiementsFactures',
    component: ListePaiementsFactures,
    name: 'l.achat.paiements_factures',
  },
  {
    path: '/listeLotPaiementFactures',
    component: ListeLotPaiementFactures,
    name: 'l.achat.lot_paiements_factures',
  },
  {
    path: '/detailLotPaiementFacture/:id',
    component: detailLotPaiement,
    name: 'c.achat.lot_paiements_factures',
  },
  {
    path: '/editionLotPaiementFacture/:id',
    component: editionLotPaiement,
    name: 'm.achat.lot_paiements_factures',
  },
  {
    path: '/listeJournalPaiementsFactures',
    component: ListeJournalPaiementsFactures,
    name: 'l.achat.journal_paiements_factures',
  },
  {
    path: '/listeSuiviAchats',
    component: ListeSuiviAchats,
    name: 'l.achat.suivi_taches_internes',
  },
];
